"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserRepository {
    constructor(userModel, userInitializer) {
        this.getUserByToken = async (token) => {
            await this.userInitializer.ensureInitialized();
            return this.userModel.getUserByToken(token);
        };
        this.all = async () => {
            await this.userInitializer.ensureInitialized();
            return this.userModel.all();
        };
        this.addToken = async (token, refreshToken, userId) => {
            await this.userInitializer.ensureInitialized();
            return this.userModel.addToken(token, refreshToken, userId);
        };
        this.getUserByEmail = async (email) => {
            await this.userInitializer.ensureInitialized();
            return this.userModel.getUserByEmail(email);
        };
        this.putUser = async (user) => {
            await this.userInitializer.ensureInitialized();
            return this.userModel.putUser(user);
        };
        this.getTokenByRefreshToken = async (refreshToken) => {
            await this.userInitializer.ensureInitialized();
            return this.userModel.getTokenByRefreshToken(refreshToken);
        };
        this.userModel = userModel;
        this.userInitializer = userInitializer;
    }
}
exports.default = UserRepository;
//# sourceMappingURL=UserRepository.js.map